import type { WebsiteLogo } from "../../hooks/useSettings";
import type { WebsiteDto } from "../../shared/types/websiteTypes";
import type { ReduxState } from "../types/main-reducer-types";

export const getActiveWebUrl = (state: ReduxState): string | undefined =>
  state.web.active;

export const getActiveWebId = (state: ReduxState): string | undefined =>
  state.web.activeId;

export const getUserWebs = (state: ReduxState): WebsiteDto[] => state.web.webs;

export const getCustomWebLogo = (state: ReduxState): WebsiteLogo | undefined =>
  state.web.activeWebLogo;

export const getPixelStatus = (state: ReduxState): boolean =>
  state.web.pixelConnected;
